"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_STOP_DETOUR_SECONDS = void 0;
exports.MAX_STOP_DETOUR_SECONDS = 600;
//# sourceMappingURL=MAX_STOP_DETOUR_SECONDS.js.map